import React, { Component } from 'react';

class ModalInformarProximoPaso extends Component {

    constructor(props) {
        super(props);
    }
    render() {
        const {
            barraAvance,
        } = this.props;

        //ACTIONS
        const {
            mostrarOcultarModalContabilizadorRecontabilizador
            
        } = this.props; 
        
            return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS'>
                    <div className='text-right'>
                        <label onClick={() => mostrarOcultarModalContabilizadorRecontabilizador("modalInformarProximoPaso", false)} className='ti-close clickable ABMModelos__modalConfirmarEliminacionRenglon__botonCerrar'></label>
                    </div>

                    <div className='modalConfirmarSalirTextoContabilizadorRecontabilizador'>
                    {"Se iniciara el proceso a partir del paso " + barraAvance[0].ProximoPaso} 
                    </div>
                    <div className='modalProcesosFooterShort'>
                        <button className="btn btn-cta" onClick={() => mostrarOcultarModalContabilizadorRecontabilizador("modalInformarProximoPaso", false)}>Aceptar</button>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalInformarProximoPaso;
